import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import { configurationApi } from "~/api";
import { getErrorMessage } from "~/hooks/helpers";
import type { Workflow } from "~/types/api";

const fetchWorkflows = async (showCompleted?: boolean): Promise<Workflow[]> => {
  const response = await configurationApi.client.GET("/api/Workflow", {
    params: { query: { showCompleted } },
  });

  if (response?.error) {
    const error = getErrorMessage(response.error, "Failed to fetch workflows");
    throw new Error(error);
  }
  if (response?.response?.status < 200 || response?.response?.status > 299) {
    throw new Error("Unexpected response status: " + response.response.status);
  }

  return response.data || [];
};

export const useWorkflowsQuery = (
  showCompleted?: boolean,
  options?: Omit<UseQueryOptions<Workflow[], Error>, "queryKey" | "queryFn">
) => {
  return useQuery<Workflow[], Error>({
    queryKey: [
      ...configurationApi.queryOptions("get", "/api/Workflow").queryKey,
      { showCompleted },
    ],
    queryFn: () => fetchWorkflows(showCompleted),
    retry: 1,
    meta: {
      errorTitle: "Failed to load workflows",
    },
    ...options,
  });
};
